export const jordanGovernorates = [
  { name: 'Irbid', visualX: 38, visualY: 10, description: 'Northern educational hub.' },
  { name: 'Ajloun', visualX: 18, visualY: 18, description: 'Lush forest highlands.' },
  { name: 'Jerash', visualX: 56, visualY: 18, description: 'Historic Roman ruins.' },
  { name: 'Mafraq', visualX: 82, visualY: 15, description: 'Northern desert gateway.' },
  { name: 'Balqa', visualX: 18, visualY: 42, description: 'Historic city of Salt.' },
  { name: 'Amman', visualX: 50, visualY: 45, description: 'The capital city.' },
  { name: 'Zarqa', visualX: 82, visualY: 40, description: 'Industrial center.' },
  { name: 'Madaba', visualX: 35, visualY: 62, description: 'City of Mosaics.' },
  { name: 'Karak', visualX: 58, visualY: 74, description: 'South fortress city.' },
  { name: 'Tafilah', visualX: 30, visualY: 84, description: 'Nature and history.' },
  { name: 'Maan', visualX: 75, visualY: 86, description: 'Desert majesty.' },
  { name: 'Aqaba', visualX: 18, visualY: 96, description: 'Red Sea port.' }
];